/**
 * @generated SignedSource<<2850acd6a66218953ca6f48175a2c595>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useHandleTemplateChangeIssueForm$data = {
  readonly __typename: "IssueForm";
  readonly __id: string;
  readonly assignees: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"AssigneePickerSharedAssignee">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly filename: string;
  readonly labels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"LabelPickerLabel">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"ProjectPickerProject" | "ProjectPickerRelay">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly title: string | null | undefined;
  readonly type: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFormElements_templateElements">;
  readonly " $fragmentType": "useHandleTemplateChangeIssueForm";
};
export type useHandleTemplateChangeIssueForm$key = {
  readonly " $data"?: useHandleTemplateChangeIssueForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHandleTemplateChangeIssueForm">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useHandleTemplateChangeIssueForm"
};

(node as any).hash = "e45114c04bea75f5d61f935829eaaf03";

export default node;
